import { useState, useEffect } from 'react';

const navLinks = [
  { label: '소개', href: '#about' },
  { label: '서비스', href: '#services' },
  { label: '클라이언트', href: '#clients' },
  { label: '문의', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-600 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-10 h-32">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, '#hero')}
          className="flex items-center h-14 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/7e3352e848b93c3eb9a2ea481cb871cb/513bb4a137418228aa54dc71c4f368f7.png"
            alt="Studio Dissolve"
            className="h-14 w-auto object-contain"
            style={{ filter: scrolled ? 'none' : 'brightness(0) invert(1)' }}
          />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`font-sans-kr text-xs tracking-widest-kr uppercase transition-all duration-400 pb-0.5 border-b border-transparent hover:border-current cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-studio-charcoal' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <button
          className={`md:hidden flex flex-col gap-1.5 cursor-pointer p-2 ${
            scrolled ? 'text-studio-black' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴"
        >
          <span className={`block w-5 h-px bg-current transition-all duration-400 ${menuOpen ? 'rotate-45 translate-y-2.5' : ''}`} />
          <span className={`block w-5 h-px bg-current transition-all duration-400 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-5 h-px bg-current transition-all duration-400 ${menuOpen ? '-rotate-45 -translate-y-2.5' : ''}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-studio-border">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.label} className="border-b border-studio-border last:border-b-0">
                <a
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block px-10 py-4 font-sans-kr text-xs tracking-widest-kr uppercase text-studio-charcoal hover:text-studio-black cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
